import React from 'react';
import { PropertyAttributes } from '../../../../../Interface/Response/Interest/PropertyAttributes';
import { ValueType } from '../../../../../Enum/ProductProperties/ValueType';
import { Boolean, Hours, Month, Months, Percentage } from '../CellTypes';
import FormattedPrice from '../../../../General/FormattedPrice';

type Props = PropertyAttributes;

export const PropertyAttribute: React.FC<Props> = ({ value, type, remark, info, viisiNote }: Props) => (
    <>
        {type === ValueType.ABSOLUTE_VALUE && (<>{value}</>)}
        {type === ValueType.AMOUNT && (<FormattedPrice price={value} />)}
        {(type === ValueType.BOOLEAN || type === ValueType.PROPOSE) && (<Boolean value={value} />)}
        {type === ValueType.HOURS && (<Hours value={parseInt(value)} />)}
        {type === ValueType.MONTHS && (<Months value={value} />)}
        {type === ValueType.MONTH && (<Month value={parseInt(value)} />)}
        {type === ValueType.PERCENTAGE && (<Percentage value={value} />)}
        {type === ValueType.UNKNOWN && (info === undefined || remark !== undefined || viisiNote !== undefined) && (
            <>Onbekend</>
        )}
        {type === ValueType.INAPPLICABLE && (<>N.v.t.</>)}
    </>
);
